import { FormValues } from '../../formFields'

type ComputeTargetRangeArgs = {
  initialValues: FormValues
  currentValues: FormValues
}

export function computeAutomaticRange(
  args: ComputeTargetRangeArgs,
): uui.domain.client.rm.RecurrenceTargetRange | undefined {
  const { initialValues, currentValues } = args

  const initialValuesWasNoRepeat =
    initialValues.recurrenceSettings.status === 'exact' &&
    initialValues.recurrenceSettings.value.recurrencePeriod.recurrenceType === 'NO_REPEAT'

  const currentValuesIsRepeat =
    currentValues.recurrenceSettings.status === 'exact' &&
    currentValues.recurrenceSettings.value.recurrencePeriod.recurrenceType !== 'NO_REPEAT'

  if (initialValuesWasNoRepeat && currentValuesIsRepeat) {
    return 'REPEAT'
  }

  const initialValuesWasMixed = initialValues.recurrenceSettings.status === 'mixed'

  const initialValuesWasRepeat =
    initialValues.recurrenceSettings.status === 'exact' &&
    initialValues.recurrenceSettings.value.recurrencePeriod.recurrenceType !== 'NO_REPEAT'

  const currentValuesIsNoRepeat =
    currentValues.recurrenceSettings.status === 'exact' &&
    currentValues.recurrenceSettings.value.recurrencePeriod.recurrenceType === 'NO_REPEAT'

  if ((initialValuesWasRepeat || initialValuesWasMixed) && currentValuesIsNoRepeat) {
    return 'NOT_REPEAT'
  }
}
